<template>
  <!--
    智课独立路由容器：不嵌套全局 Layout，避免与 StandaloneAdminLayout 双侧重壳。
    各业务页自行挂 AiEducationLayout（含左侧菜单）。
  -->
  <RouterView />
</template>

<script setup lang="ts">
defineOptions({ name: 'AiEducationRouteLayout' })
</script>
